import { render, staticRenderFns } from "./ProductsBuyTogether.vue?vue&type=template&id=6699b88c&"
import script from "./ProductsBuyTogether.vue?vue&type=script&lang=js&"
export * from "./ProductsBuyTogether.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBuyTogether.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports